/**
 * @file TopAnimate
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname TopAnimate
 * @classdesc アコーディオン
 */
export default class TopAnimate {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('TopAnimate.constructor')
		this._$e = $e
		var self = this; 
		$(window).scroll(function() {
			var windowHeight = $(window).height();
			var elementOffsetTop = self._$e.offset().top;
		
			if (elementOffsetTop + 100 < (windowHeight + $(window).scrollTop())) {
				self._$e.addClass('active');
			}
		});
	}
}
